import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* 顶部公告条：社区更新动态 */}
      <div className="bg-primary-950 text-primary-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2 text-xs md:px-6">
          <div className="flex min-w-0 items-center gap-2">
            <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-accent-500 text-primary-950">
              <i className="ri-flashlight-fill text-[9px]" />
            </span>
            <p className="truncate font-label tracking-wide">
              快讯：<span className="text-foreground-50">应援对账合集今日更新至第 53 条</span>
            </p>
          </div>
          <div className="hidden items-center gap-4 text-foreground-300 sm:flex">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-radio-line text-primary-300" />
              讨论热度 <b className="text-accent-400">12.8万</b>
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-time-line text-primary-300" />
              更新于 09:12
            </span>
          </div>
        </div>
      </div>

      {/* 主导航：轻杂志壳，品牌突出 */}
      <div
        className={`border-b transition-colors duration-300 ${
          scrolled ? 'border-background-200 bg-background-50/90 backdrop-blur' : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-6 md:py-5">
          {/* 品牌 lockup */}
          <a href="#top" className="group flex items-baseline gap-1.5" aria-label="51黑料 首页">
            <span className="font-display text-2xl font-black tracking-tight text-primary-600 md:text-3xl">
              51<span className="text-accent-600">黑料</span>
            </span>
            <span className="hidden font-heading text-sm text-foreground-400 md:inline">话题热榜 · 盘点精选</span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#hot"
              className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-fire-fill text-base" />
              看今日热榜
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 transition hover:bg-secondary-100 md:hidden"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
            <nav className="grid grid-cols-2 gap-2 pt-3" aria-label="移动端导航">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap rounded-md bg-secondary-50 px-4 py-3 text-sm text-foreground-800 transition hover:bg-primary-100 hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}